export default {"src":"/_next/static/image/public/assets/icons/time.f75807876ed9b125d93a41c0e185cabe.svg","height":24,"width":24};